import { render } from "./SectionLeaveForm.vue?vue&type=template&id=61630c2a&scoped=true"
import script from "./SectionLeaveForm.vue?vue&type=script&lang=js"
export * from "./SectionLeaveForm.vue?vue&type=script&lang=js"

import "./SectionLeaveForm.vue?vue&type=style&index=0&id=61630c2a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61630c2a"]])

export default __exports__